export default __webpack_public_path__ + "static/media/pic3.17975426.jpg";